<script setup lang="ts">
import { $currency } from "@/vf"
withDefaults(
    defineProps<{
        price?: any
    }>(),
    {
        price: undefined,
    },
)
</script>

<template>
    <template v-if="price === undefined">
        <div class="spinner-grow" style="width: 1em; height: 1em"></div>
    </template>
    <template v-else>
        {{ $currency(price) }}
    </template>
</template>
